<template>
    <a class="font-fauli text-pink-100 hover:underline" 
       :href="props.model.urlLink ?? ''" 
       target="_blank"
       v-html="props.model.linkText">    
    </a>
</template>

<script lang="ts" setup>
import { LinkBlock } from '@/api/content/models';

type Props = {
    model: LinkBlock
}

const props = defineProps<Props>();

</script>
